module.exports = __webpack_public_path__ + "img/lightening-green.8d4453b8.svg";